import { renderInDocument } from '@spotahome/bff/client';

import SearchPage from './main';

// Styles
import '../../common/scss/init.scss';

renderInDocument(SearchPage);
